/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarAppointmentBook { 
    startDate: string;
    patientId: string;
    therapistId: number;
    ignoreWarnings?: boolean;
    appointmentTypeId: number;
}
export const CalendarAppointmentBook_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAppointmentBook_patientId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAppointmentBook_therapistId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAppointmentBook_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];

export const CalendarAppointmentBook_appointmentTypeId_Validators: ValidatorFn[] =
    [  Validators.required, ];


